import moment from 'moment'
import Immutable from 'immutable'
import BigNumber from 'bignumber.js'

export function recomposeInvoice(result) {
  const { content } = result
  if (!content?.invoicer) return initialState.invoice
  content.recipients = content.recipents?.map((r, index) => ({
    ...r,
    id: Date.now().toString() + index,
  }))
  content.invoice = Immutable.Map(content.invoicer)
  content.items = content.items?.map((r, index) => ({
    ...r,
    unitPriceAmount: r.unitPriceAmount?.amount || 0,
    id: Date.now().toString() + index,
  }))
  content.lastUpdatedTime = result.lastUpdatedTime
  content.orderId = result.id
  content.status = result.status
  content.summary = content.amount
  content.invoiceTime = result.invoiceTime
  return Immutable.fromJS(content)
}

export function calcDiscount(summary) {
  const discount = summary.get('discount')
  let discountRate = summary.get('discountRate')
  const subTotal = summary.get('subTotal')
  const discountType = discount ? DiscountType.AED : DiscountType.Rate
  discountRate = String(discountRate).replace(/,/g, '') || 0
  if (discountType !== DiscountType.Rate) {
    return new BigNumber(discount.get('amount')).negated()
  }
  return new BigNumber(subTotal)
    .multipliedBy(discountRate)
    .dividedBy(100)
    .negated()
}

export function calcItemAmount(item) {
  const quantity = item.get('quantity')
  const unitPriceAmount = String(item.get('unitPriceAmount')).replace(/,/, '')
  return new BigNumber(quantity).multipliedBy(unitPriceAmount)
}

export function itemsFactory() {
  return {
    id: Date.now().toString(),
    description: '',
    quantity: 1,
    unitPriceAmount: 0,
    vat: '0.05',
  }
}
export const initialState = {
  isFetching: true,
  invoice: Immutable.fromJS({
    invoice: {},
    billTo: {},
    recipients: [],
    items: [itemsFactory()],
    summary: {
      discount: { currency: 'AED', amount:0 },
      subTotal:  { currency: 'AED', amount:0 },
      total:  { currency: 'AED', amount:0 },
      discountRate: 0,
      tax:  { currency: 'AED', amount:0 },
    },
  }),
}

export const DateFormatterConstant = 'DD/MM/YYYY'
export function handleDate(date, formatter = DateFormatterConstant) {
  return date ? moment(date).format(formatter) : ''
}

export const DiscountType = {
  Rate: '%',
  AED: 'AED',
}

export const InvoiceStatus = {
  Draft         : 'DRAFT',
  Unpaid        : 'UNPAID',
  Paid          : 'PAID',
  Cancelled     : 'CANCELLED',
  Uncollectible : 'UNCOLLECTABLE'
}
